<template>
  <L1 class="ProductInformation">
    <template slot="slot_title">
      <!-- <button class="addBtn" @click="addProduct=true">新增不分潤商品</button> -->
      <Select :width="'165px'" :style="{height: '40px'}" :defaultValue="type" @input="type=$event">
        <option :value="null">全部</option>
        <option :value="'ticket'">門票</option>
        <option :value="'noprofit'">二消商品</option>
      </Select>
      <Select :width="'190px'" :defaultValue="countable" @input="countable=$event">
        <option :value="null">全部</option>
        <option :value="true">分潤計算</option>
        <option :value="false">不分潤計算</option>
      </Select>
      <input type="text" :style="{padding: '1px 2px', width: '300px'}" class="search" placeholder="搜尋" v-model="searchText">
      <input type="radio" v-model="filterType" value="全部" :style="{marginLeft: 'auto'}">
      <input type="radio" v-model="filterType" value="吧檯">
      <input type="radio" v-model="filterType" value="松柏軒">
      <input type="radio" v-model="filterType" value="植栽">
      <input type="radio" v-model="filterType" value="票務">
      <input type="radio" v-model="filterType" value="內部用品">
      <input type="radio" v-model="filterType" value="待定">
    </template>
    <Table :rows="products">
        <template slot="slot_head">
          <th :style="{width: '96px'}">No.</th>
          <th :style="{textAlign:'start', width: 'inherit'}">品項</th>
          <th :style="{width: '160px', textAlign:'start'}">貨編</th>
          <!-- <th :style="{width: '90px'}">售價</th> -->
          <th :style="{width: '150px'}">商品類型</th>
          <th :style="{width: '90px'}">分潤計算</th>
          <th :style="{width: '300px', textAlign:'start'}">區域組別</th>
          <th :style="{width: '60px'}">編輯</th>
          <th :style="{width: '60px'}">刪除</th>
        </template>
        <tr slot-scope="item" :style="{height:'64px', border:'none'}">
          <td>{{(item.index + 1).toString().padStart(3, '0')}}</td>
          <td :style="{textAlign:'start'}">{{item.item.name}}</td>
          <td :style="{textAlign:'start'}">{{item.item.id}}</td>
          <!-- <td>{{item.item.price}}</td> -->
          <td><span v-if="item.item.type==='noprofit'">二消商品</span><span v-else-if="item.item.type==='ticket'">門票</span></td>
          <td><input type="checkbox" v-model="item.item.disabled" @click="updateProduct($event, item.item)"></td>
          <td :style="{textAlign:'start'}">{{item.item.area?.join(' | ')}}</td>
          <td>
            <button class="editbtn" @click="product=item.item">
            </button>
          </td>
          <td>
            <button class="delbtn" @click="deleteItem={index:item.index, _id: item.item._id, name: item.item.name}">
            <!-- <iconDelete color2="#FFFFFF" color="#E37878" :width="40" :height="40"/> -->
            </button>
          </td>
        </tr>
    </Table>
    <editProductC @updateProduct="updateProductItem" v-if="product" :show="product" :product="product" @close="product=null"/>
    <ConfirmDiag v-if="deleteItem" :show="deleteItem" @close="deleteItem=null" :text="`確定要刪除 ${deleteItem.name} 嗎?`" :label="'刪除'" @confirm="deleteProduct(deleteItem.index, deleteItem._id)" @cancel="deleteItem=null"/>
    <!-- <NewProductC @new="newProduct" v-if="addProduct" :show="addProduct" @close="addProduct=false"/> -->
  </L1>
</template>

<script>
import L1 from '../components/layout/L1.vue'
import Table from '../components/tables/t2.vue'
import Select from '../components/select.vue'
import ConfirmDiag from '../components/comfirm.vue'
import editProductC from './partial/editProduct.vue'
// import NewProductC from './partial/NewProduct.vue'
import { getapi, postapi, deleteapi } from '../store/fetch'
export default {
  name: 'ProductInformation',
  components: {
    // iconEdit,
    // iconDelete,
    // NewProductC,
    editProductC,
    ConfirmDiag,
    Select,
    Table,
    L1
  },
  data () {
    return {
      deleteItem: null,
      filterType: '吧檯',
      product: null,
      addProduct: false,
      products: [],
      searchText: null,
      type: null,
      countable: null
    }
  },
  async created () {
    await this.getNoProfit()
  },
  watch: {
    filterType () {
      this.getNoProfit()
    },
    type () {
      this.getNoProfit()
    },
    countable () {
      this.getNoProfit()
    },
    searchText () {
      this.getNoProfit()
    }
  },
  methods: {
    updateProductItem (data) {
      const index = this.products.map(e => e._id).indexOf(data._id)
      this.products.splice(index, 1, data)
      this.product = null
    },
    async updateProduct (event, data) {
      // console.log(data.disabled)
      await postapi(`products/${data._id}`, { disabled: !data.disabled })
    },
    async deleteProduct (index, id) {
      const r = await deleteapi(`products/${id}`)
      if (r) {
        this.products.splice(index, 1)
      }
    },
    newProduct (data) {
      this.products.push(data)
      this.addProduct = false
    },
    async getNoProfit () {
      const params = {}
      if (this.filterType !== '全部') {
        params.area = this.filterType
      } else if (this.filterType === '其他') {
        params.area = this.filterType
      }
      if (this.filterType !== '全部') {
        params.category = this.filterType
      }
      if (this.searchText) {
        params.search = this.searchText
      }
      if (this.type) {
        params.type = this.type
      }
      if (this.countable !== null) {
        params.countable = this.countable
      }
      this.products = await getapi('products/noprofit?' + new URLSearchParams(params))
    }
  }

}
</script>
<style lang="scss">
.ProductInformation {
  .slot_title {
    margin-left: 10px!important;
    padding-left: 0!important;
    gap: 15px!important;
  }
}
</style>
<style lang="scss" scoped>
table button {
  background-color: transparent;
}
.delbtn {
  background-image: url(/svg/btn/del.svg);
  width: 35px;
  height: 35px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 25px 27px;
}
.editbtn {
  background-image: url(/svg/btn/edit.svg);
  width: 35px;
  height: 35px;
  background-color: var(--color-checked);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 19px;
  border-radius: 50%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
}
table input[type=checkbox] {
  appearance: none;
  // width: 39px;
  // height: 20px;
  // border-radius: 10px;
  // background-color: #85CA9E;
  // border: 2px solid #85CA9E;
  // position: relative;
  // &::before {
  //   position: absolute;
  //   content: '';
  //   background-color: #FFFFFF;
  //   border-radius: 9px;
  //   display: inline-block;
  //   width: 16px;
  //   height: 16px;
  //   top: 0px;
  //   right: 0;
  // }
  // &:checked::before {
  //   left: auto;
  //   left: 0;
  // }
  // &:checked {
  //   background-color: #E37878;
  //   border: 2px solid #E37878;
  // }
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  background-image: url(/svg/checkbox/greyCheckmark.svg);
  &:checked {
    background-image: url(/svg/checkbox/greenCheckmark.svg);
  }
  width: 35px;
  height: 30px;
}
.addBtn {
  background-color: var(--color-checked);
  width: 216px;
  height: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  border-radius: 50px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  margin: 0;
  gap: 3px;
  &::before {
  content: '';
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;

  }
}

.addBtn::before {
  width: 29px;
  height: 29px;
  background-image: url(/plus.svg);
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-top: 8px;
  &::placeholder {
    color: var(--color-border);
  }

}
.ProductInformation {
  padding-inline: 18px 9px!important;
  .content {
    display: grid;
    grid-template-columns: 645px 1fr;
    grid-template-rows: calc(100vh - 89px);
    &>:nth-child(1) {
      border-right: 1px solid var(--color-border);
    }
    &>div {
      width: 100%;
      height: 100%;
      padding-block: 28px;
      padding-inline: 50px;
      box-sizing: border-box;
    }
  }
 }
.header {
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 15px;
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
input[type=radio] {
  min-width: 78px;
  white-space: nowrap;
  border-radius: 3px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  padding-inline: 10px;
  height: 40px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  &::before {
    content: attr(value);
  }
  background-color: #C4C4C4;
  color: #FFFFFF;
  &:checked {
    background-color: var(--color-checked);
    color: #FFFFFF;
  }
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}
</style>
